<form [formGroup]="nmibleCardForm">
  <div class="row">
    <div class="col-md-6">
      <div class="mb-3" *ngIf="cards.length">
        <h3 class="text-muted mb-2">Virtual Cards</h3>
        <table class="table table-sm">
          <thead>
            <tr>
              <th>Country</th>
              <th>Created</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let card of cards">
              <td>{{ card.country }}</td>
              <td>{{ card.created | date:'d MMM y' }}</td>
              <td>
                <span class="badge badge-success" *ngIf="card.selected">Selected</span>
              </td>
              <td class="text-right">
                <app-button text="Select" type="button" variant="secondary" size="sm" className="mr-1" *ngIf="!card.selected && canWritePaymentInfo"
                  [disabled]="processing" (clicked)="selectCard(card.optionId)" />
                <app-button text="View" type="button" variant="tertiary" size="sm" className="mr-1"
                  [disabled]="processing" (clicked)="viewCard(card)" />
                <app-button text="Remove" type="button" variant="info" size="sm" *ngIf="canWritePaymentInfo"
                  [disabled]="processing" (clicked)="confirmRemoveCard(card.optionId)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-container *ngIf="viewedCard">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h3 class="text-muted m-0 mr-2">Card Details <span class="text-muted">({{ viewedCard.country }})</span></h3>
          <button type="button" class="btn btn-primary btn-sm mb-0" (click)="highnoteCardViewer.onToggleMask()">Toggle
            Card
            Number</button>
        </div>

        <hr class="my-2">

        <div class="d-flex justify-content-center">
          <app-highnote-card-viewer #highnoteCardViewer (retryRequired)="getVisualisationDetails(viewedCard.optionId)"></app-highnote-card-viewer>
        </div>

        <hr class="my-2">

        <div class="mt-3" *ngIf="balance !== undefined && balance !== null">
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted font-weight-bold">Balance</span>
            <span class="font-weight-bold h5 mb-0">{{ balance | number:'1.2-2' }} {{ currency || 'USD' }}</span>
          </div>
        </div>
      </ng-container>

      <div class="mt-3">
        <mat-accordion multi="false">
          <!-- Option 1: Create New Card -->
          <mat-expansion-panel
            [disabled]="!canWritePaymentInfo"
            [expanded]="canWritePaymentInfo && cardCreationType === 'new'"
            (opened)="cardCreationType = 'new'">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <label>Create new card</label>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <table class="simple-form">
              <tbody>
                <ng-container *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
                  <tr>
                    <th><label for="givenName">First Name <sup>*</sup></label></th>
                    <td>
                      <div class="form-group">
                        <input type="text" id="givenName" class="form-control" formControlName="givenName">
                        <span class="validation-error"
                          *ngIf="nmibleCardForm.get('givenName').touched && nmibleCardForm.get('givenName').hasError('required')">First
                          Name is required</span>
                        <span class="validation-error"
                          *ngIf="nmibleCardForm.get('givenName').touched && nmibleCardForm.get('givenName').hasError('pattern')">First
                          Name can only contain letters</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th><label for="middleName">Middle Name</label></th>
                    <td>
                      <div class="form-group">
                        <input type="text" id="middleName" class="form-control" formControlName="middleName">
                        <span class="validation-error"
                          *ngIf="nmibleCardForm.get('middleName').touched && nmibleCardForm.get('middleName').hasError('pattern')">Middle
                          Name can only contain letters</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th><label for="familyName">Last Name <sup>*</sup></label></th>
                    <td>
                      <div class="form-group">
                        <input type="text" id="familyName" class="form-control" formControlName="familyName">
                        <span class="validation-error"
                          *ngIf="nmibleCardForm.get('familyName').touched && nmibleCardForm.get('familyName').hasError('required')">Last
                          Name is required</span>
                        <span class="validation-error"
                          *ngIf="nmibleCardForm.get('familyName').touched && nmibleCardForm.get('familyName').hasError('pattern')">Last
                          Name can only contain letters</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th><label for="country">Country <sup>*</sup></label></th>
                    <td>
                      <div class="form-group">
                        <app-autosuggest-dropdown-input #countrySelect [options]="countries"
                          [parentForm]="nmibleCardForm" controlName="country"
                          placeholder="Select country..."></app-autosuggest-dropdown-input>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th><label for="currency">Currency</label></th>
                    <td>
                      <div class="form-group">
                        <input type="text" id="currency" class="form-control" formControlName="currency">
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th><label for="email">Email <sup>*</sup></label></th>
                    <td>
                      <div class="form-group">
                        <input type="email" id="email" class="form-control" formControlName="email">
                        <span class="validation-error"
                          *ngIf="nmibleCardForm.get('email').touched && nmibleCardForm.get('email').hasError('required')">Email
                          is required</span>
                        <span class="validation-error"
                          *ngIf="nmibleCardForm.get('email').touched && nmibleCardForm.get('email').hasError('pattern')">Email
                          is invalid</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <label class="checkbox">
                      <input formControlName="consent" id="consent" type="checkbox">
                      <span></span>
                    </label>
                    <label class="checkbox-label" for="consent">I confirm that I have seen and verified patient
                      consent <sup>*</sup></label>
                  </tr>
                  <tr
                    *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails) && authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
                    <th></th>
                    <td>
                      <button [disabled]="nmibleCardForm.invalid || processing"
                        class="btn btn-primary test-connection-btn w-100" (click)="createVirtualCard()">
                        <span *ngIf="processing" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                        <span *ngIf="!processing">Create Nmible Virtual Card</span>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </mat-expansion-panel>

          <!-- Option 2: Use Existing Card -->
          <mat-expansion-panel
            [disabled]="!canWritePaymentInfo"
            [expanded]="canWritePaymentInfo && cardCreationType === 'existing'"
            (opened)="cardCreationType = 'existing'">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <label>Use existing card</label>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="option-content mt-3" *ngIf="canWritePaymentInfo && cardCreationType === 'existing'">
              <form [formGroup]="assignCardForm">
                <div class="form-group">
                  <label for="patientName">Patient</label>
                  <app-patient-autocomplete #patientAutoComplete [options]="patientSuggestions"
                    [parentForm]="assignCardForm" [required]="true" controlName="patientName"
                    (selectionChanged)="onPatientSelected($event)" placeholder="Patient Name or Id...">
                  </app-patient-autocomplete>
                </div>

                <div class="form-group mt-3">
                  <label class="checkbox">
                    <input formControlName="consent" id="consentExisting" type="checkbox">
                    <span></span>
                  </label>
                  <label class="checkbox-label" for="consentExisting">I confirm that I have seen and verified patient
                    consent <sup>*</sup></label>
                </div>

                <div class="form-group mt-3" *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
                  <button [disabled]="assignCardForm.invalid || processing" class="btn btn-primary w-100"
                    (click)="assignNmibleVirtualCard()">
                    <span *ngIf="processing" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                    <span *ngIf="!processing">Assign Nmible Virtual Card</span>
                  </button>
                </div>
              </form>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</form>

<app-confirm-action-modal #confirmRemoveCardModal (confirmed)="removeCard($event)" />
